import { Expose, Type } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class HouseholdClaimDecisionTreeModel extends BaseModel {
    @Expose() id = 0;
    @Expose() level = 0;
    @Expose() order = 0;
    @Expose() label = "";
    @Expose()
    @Type(() => HouseholdClaimDecisionTreeModel)
    children: HouseholdClaimDecisionTreeModel[] = [];
}
